import { EnumReadinDtoProps } from "./DTOs/EnumReadinDto"

export const codigoFacturaRectificativaAdapter = (item: EnumReadinDtoProps) => {
  return {
    id: item?.id,
    description: item?.description,
  }
}
